import { useTranslation } from 'react-i18next'

import { useAuth } from '@features/auth'
import { useErrorInfoModal, useModalStore } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods/model/useAddressStore'
import { AddressItemType, PickupShop } from '@features/shipping-methods/types'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'



export default function DeleteAddressModal ({
  shop,
  onSuccess,
}: {
  shop: PickupShop | AddressItemType;
  onSuccess: () => void;
}) {
  const { t: tc } = useTranslation('common')
  const { t: tmd } = useTranslation('modalDelivery')
  const { t: te } = useTranslation('errors')
  const { openErrorInfoModal } = useErrorInfoModal()
  const { closeModal } = useModalStore()
  const { isAuthorized } = useAuth()
  const { removeAddress, deleteAddress } = useAddressStore()

  const handleDeleteShop = async (shop: PickupShop | AddressItemType) => {
    try {
      if (isAuthorized) {
        await deleteAddress(shop?.id as string)
      }
      else {
        removeAddress(shop?.id as string)
      }
    }
    catch (err) {
      console.error('Error saving address:', err)
      openErrorInfoModal({
        description: te('delete_address'),
      })
    }
    finally {
      closeModal('deleteAddress')
      onSuccess()
    }
  }

  return (
    <div className={styles.modal}>
      <p>
        {tmd('shop.delete_confirm')} <span>{shop?.address}</span>
      </p>
      <div className={styles.modal__buttons}>
        <Button onClick={() => handleDeleteShop(shop)}>{tc('yes')}</Button>
        <Button onClick={() => closeModal('deleteAddress')} theme="grey">
          {tc('no')}
        </Button>
      </div>
    </div>
  )
}
